import type { ComponentType } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';

import type { AdjacentRound } from '../../../../../../../model/AdjacentRound/adjacentRound';
import { getParticipationInfo } from '../../../../../../../model/AdjacentRound/roundParticipation';
import { PredictionRoundState } from '../../../../../../../model/AdjacentRound/roundState';
import { ActivePredictionButton } from './ActivePredictionButton';
import type { PredictionButtonProps } from './ButtonProps';
import { ClosedPredictionButton } from './ClosedPredictionButton';
import { LockedPredictionButton } from './LockedPredictionButton';

type PredictionCardButtonsProps = {
  round: AdjacentRound;
};

type ButtonStateMap = Record<PredictionRoundState, ComponentType<PredictionButtonProps>>;

const ButtonsMap: ButtonStateMap = {
  [PredictionRoundState.CLOSED]: ClosedPredictionButton,
  [PredictionRoundState.LOCKED]: LockedPredictionButton,
  [PredictionRoundState.ACTIVE]: ActivePredictionButton,
};

export const PredictionCardButtons = ({ round }: PredictionCardButtonsProps) => {
  const { userEvmWallet } = useAuth();
  const participation = getParticipationInfo({ round, wallet: userEvmWallet?.attributes.address });
  const Button = ButtonsMap[round.state];

  return <Button round={round} participation={participation} />;
};
